"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_SELECTED_LANGUAGE = exports.SET_SELECTED_CURRENCY = exports.SET_AVAILABLE_CURRENCIES = exports.SET_AVAILABLE_LANGUAGES = void 0;
const LOCALIZATION_REDUCER = 'LOCALIZATION_REDUCER/';
exports.SET_AVAILABLE_LANGUAGES = `${LOCALIZATION_REDUCER}SET_AVAILABLE_LANGUAGES`;
exports.SET_AVAILABLE_CURRENCIES = `${LOCALIZATION_REDUCER}SET_AVAILABLE_CURRENCIES`;
exports.SET_SELECTED_CURRENCY = `${LOCALIZATION_REDUCER}SET_SELECTED_CURRENCY`;
exports.SET_SELECTED_LANGUAGE = `${LOCALIZATION_REDUCER}SET_SELECTED_LANGUAGE`;
